import React, { useEffect, useState } from 'react'

const TOAST_VARIANTS = {
  success: {
    bg: 'bg-[#509A9A]',
    icon: (
      <svg width="18" height="14" viewBox="0 0 18 14" fill="none">
        <path
          d="M1 7L6 12L17 1"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  error: {
    bg: 'bg-[#E54D4D]',
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="9" cy="9" r="8" stroke="white" strokeWidth="2" />
        <path
          d="M6 6L12 12M12 6L6 12"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
}

const ToastItem = ({ message, type = 'success', onClose }) => {
  const [isDismissing, setIsDismissing] = useState(false)
  const variant = TOAST_VARIANTS[type] || TOAST_VARIANTS.success

  useEffect(() => {
    const timer = setTimeout(() => setIsDismissing(true), 4500)
    const closeTimer = setTimeout(onClose, 5000)
    return () => {
      clearTimeout(timer)
      clearTimeout(closeTimer)
    }
  }, [onClose])

  return (
    <div
      className={`
        w-full fixed top-0 left-0 z-[9999] pointer-events-auto
        text-white px-6 py-4 shadow-lg font-primary!
        ${variant.bg} 
        ${isDismissing ? 'animate-slide-out-top' : 'animate-slide-in-top'}
      `}
    >
      <div className="flex items-center justify-center gap-3">
        <div className="shrink-0">{variant.icon}</div>
        <span className="text-base font-bold! leading-tight tracking-tight">
          {message}
        </span>
      </div>
    </div>
  )
}

export default ToastItem
